var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTryAgainIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "try_again_icon",
    d: "M4,2A1,1,0,0,1,5,3V5.1A7,7,0,0,1,16.6,7.667a1,1,0,1,1-1.885.666A5,5,0,0,0,6,7H9A1,1,0,0,1,9,9H4A1,1,0,0,1,3,8V3A1,1,0,0,1,4,2Zm.008,9.057a1,1,0,0,1,1.276.61A5,5,0,0,0,14,13H11a1,1,0,0,1,0-2h5a1,1,0,0,1,1,1v5a1,1,0,0,1-2,0V14.9A7,7,0,0,1,3.4,12.333a1,1,0,0,1,.61-1.276Z",
    transform: "translate(-3 -2)",
    fill: "#fff",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTryAgainIcon);
export default __webpack_public_path__ + "static/media/try_again_icon.c55e2036bfa139d485159195778dbec8.svg";
export { ForwardRef as ReactComponent };